/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useMemo } from 'react';
import { Card, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { Ctx } from 'components/CtxFormFields/CtxInputs';
import RenderFormItem from 'components/CtxFormFields/FormFieldCtx';
import useErrorState, { translateError } from 'utils/hooks/useErrorState';

import { cayanFields, cayanDefaultState } from './formShape';

function Cayan() {
  const formContext = useContext(Ctx);
  const { integrationState, loading, setEnabledSave } = formContext.values;
  const { level } = useParams();

  const values = useMemo(
    () => ({ ...cayanDefaultState, ...integrationState }),
    [cayanDefaultState, integrationState],
  );

  const { errors, hasErrors } = useErrorState(values, {
    ...cayanFields.pos,
    ...cayanFields.account,
  });

  useEffect(() => {
    setEnabledSave(!hasErrors);
  }, [errors]);

  // Update configuration fields
  const onChange = (key, value) => {
    if (key === 'secureDeviceConnection') {
      formContext.onChange({
        [key]: !!value,
        devicePort: value ? '8443' : '8080',
      });
    } else {
      formContext.onChange({
        [key]: value,
      });
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="d-flex flex-column flex-fill">
      <Ctx.Provider
        value={useMemo(() => ({ values, onChange }), [values, onChange])}
      >
        <Card className="flex-fill my-3">
          <Card.Header>Cayan Account Credentials</Card.Header>
          <Card.Body>
            <Form>
              {Object.values(cayanFields.account).map(
                ({ validate, ...rest }) => (
                  <RenderFormItem
                    key={rest.id}
                    name={rest.id}
                    size="md"
                    error={translateError(errors[rest.id])}
                    {...rest}
                  />
                ),
              )}
            </Form>
          </Card.Body>
        </Card>

        {level === 'Pos' && (
          <Card className="flex-fill mb-3">
            <Card.Header>Cayan POS Credentials</Card.Header>
            <Card.Body>
              <Form>
                {Object.values(cayanFields.pos).map(({ validate, ...rest }) => (
                  <RenderFormItem
                    key={rest.id}
                    name={rest.id}
                    size="md"
                    error={translateError(errors[rest.id])}
                    {...rest}
                  />
                ))}
              </Form>
            </Card.Body>
          </Card>
        )}
      </Ctx.Provider>
    </div>
  );
}

export default Cayan;
